import React from 'react';
import { FileText, Menu, Settings as SettingsIcon, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { UserButton } from '@clerk/react';
import { useAuth } from '../context/AuthContext';
import { DuckMark } from './DuckPilotLogo';

const Header = ({ selectedFile, onSidebarToggle, onOpenSettings, demoMode, onTryAnotherDataset }) => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();

  return (
    <header className="bg-paper/80 border-b border-[rgba(32,30,29,0.12)] px-4 lg:px-6 py-3 backdrop-blur-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={onSidebarToggle}
            className="lg:hidden p-2 text-sand-600 hover:bg-sand-200 rounded-brand-sm transition-colors"
          >
            <Menu className="w-5 h-5" />
          </button>

          <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => navigate('/')}>
            <DuckMark size={30} />
            <div>
              <h1 className="font-display text-[19px] text-ink leading-none">DuckPilot</h1>
              <p className="text-[11px] text-sand-600 hidden sm:block font-medium mt-0.5">AI Data Query Engine</p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2.5">
          {selectedFile && (
            <div className="hidden sm:flex items-center gap-2 bg-white rounded-full px-3.5 py-2 border border-[rgba(32,30,29,0.12)] shadow-brand-sm">
              <FileText className="w-4 h-4 text-sand-500" strokeWidth={2.25} />
              <div className="text-sm">
                <span className="text-ink font-semibold truncate max-w-48">{selectedFile.filename}</span>
                <span className="text-sand-600 ml-2 tnum">{selectedFile.row_count?.toLocaleString()} rows</span>
              </div>
            </div>
          )}

          {/* Try Another Dataset Button (Demo Mode) */}
          {demoMode && selectedFile && onTryAnotherDataset && (
            <button
              onClick={onTryAnotherDataset}
              className="hidden sm:flex items-center gap-2 px-3.5 py-2 text-sm font-semibold text-bill-700 hover:bg-bill-100 rounded-full transition-colors border border-bill-300"
              title="Try another demo dataset"
            >
              <RefreshCw className="w-4 h-4" />
              <span>Try another dataset</span>
            </button>
          )}

          <button
            onClick={onOpenSettings}
            className="p-2 text-sand-600 hover:text-ink hover:bg-sand-200 rounded-full transition-colors"
            title="Settings"
          >
            <SettingsIcon className="w-5 h-5" />
          </button>

          {/* Clerk account control (signed-in state) */}
          {isSignedIn && (
            <UserButton
              afterSignOutUrl="/"
              appearance={{ elements: { avatarBox: { width: 32, height: 32 } } }}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
